import {
  registerDecorator,
  ValidationOptions,
  ValidationArguments,
  ValidatorConstraintInterface,
  ValidatorConstraint,
} from 'class-validator';
import { ErrorCode } from '../../../constants/src';

@ValidatorConstraint({ name: '_isDate', async: false })
export class IsDateConstraint implements ValidatorConstraintInterface {
  validate(value: unknown, args: ValidationArguments) {
    if (value === null || value === undefined) {
      return false;
    }

    if (value instanceof Date) {
      return !isNaN(value.getTime());
    }

    return false;
  }

  defaultMessage(args: ValidationArguments) {
    const [errorCode] = args.constraints;

    return JSON.stringify({
      code: errorCode,
      message: `${args.property} must be a valid date`,
      path: args.property,
      params: {
        currentValue: args.value,
        expectedType: 'date',
      },
    });
  }
}

export function IsDate(
  errorCode: ErrorCode = ErrorCode.INVALID_INPUT,
  validationOptions?: ValidationOptions,
) {
  return function (object: object, propertyName: string) {
    registerDecorator({
      name: '_isDate',
      target: object.constructor,
      propertyName: propertyName,
      options: validationOptions,
      constraints: [errorCode],
      validator: IsDateConstraint,
    });
  };
}
